<template>
    <div>
        <transition name="fade">
            <tenant-welcome @next-step="step = 2" v-if="step === 1"></tenant-welcome>
        </transition>
        <transition name="fade">
            <tenant-feedback 
                @prev-step="prevStepFeedback"
                @next-step="nextStepFeedback" 
                :propertyId="property_id" 
                :siteId="site_id" 
                :userLogged="userLogged"
                v-if="step === 2">
            </tenant-feedback>
        </transition>
        <transition name="fade">
            <tenant-thanks @next-step="nextStepThank" :minute="minute" @logout="logOut" :userLogged="userLogged" v-if="step === 3"></tenant-thanks>
        </transition>
    </div>
</template>
<script>
    const tenantWelcome = () => import("./welcome")
    const tenantFeedback = () => import("./form")
    const tenantThanks = () => import("./thanks")
    export default {
        name: 'tenant-feedback-index',
        components:{
            "tenant-welcome":tenantWelcome,
            "tenant-feedback":tenantFeedback,
            "tenant-thanks":tenantThanks,
        },
        data () {
            return {
                property_id:this.$route.query.property_id || null,
                site_id:this.$route.query.site_id || null,
                step: 1,
                time_minute: null,
                minute: 60,
                userLogged: null
            }
        },
        created() {},
        methods:{
            countdown() {
                if(this.minute == -1) {
                    this.step = 1;
                    this.minute = 60;
                    clearTimeout(this.time_minute);
                    return false;
                }
                const _this = this;
                this.time_minute = setTimeout(function(){
                    _this.minute--;
                    _this.countdown();
                }, 1000);
            },
            stopCountdown() {
                clearTimeout(this.time_minute);
            },
            prevStepFeedback(step) {
                if(step == 1 && this.userLogged)
                    this.userLogged = null;
            },
            nextStepFeedback(user) {
                this.step = 3;
                if(user) {
                    this.userLogged = user;
                    this.minute = 60;
                    this.countdown();
                }
            },
            nextStepThank() {
                if(this.userLogged) {
                    this.step = 2;
                    this.stopCountdown();
                } else {
                    this.step = 1;
                }
            },
            logOut() {
                this.step = 1;
                this.userLogged = null;
            }
        }
    }
</script>
